import {composeReducers} from 'common/utils/reducers';
import {makeAsyncReducer} from 'common/utils/simplifiedAsync';
import * as actions from '../actions';

// eslint-disable-next-line import/prefer-default-export
export const fetchMetricsTotal = composeReducers(makeAsyncReducer(actions.fetchMetricsTotal, {defaultData: null}));
